<div class="form-control input-placeholder-to-label email-q">
  <label class="has-float-label">
    <input type="email" id="txtEmailAddress" placeholder="Email" name="email"
           [readonly]="isReadOnly" class="text-input text-09-d-demibold {{error.errorCss}}"
           [(ngModel)]="email" (ngModelChange)="submitAnswer($event)"
           (click)="onClick($event)">

    <span>Email</span>
  </label>  
  <p class="error" id="error-email" *ngIf="error.isInValid">Para continuar, introduce un email con este formato: nombre@dominio.com</p>
</div>

